import { format } from 'date-fns';

export const formatDate = (value?: Date): string => (value ? format(value, 'dd/MM/yyyy') : '—');

export const formatCurrency = (value: number): string =>
  new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
